export default {
    h1: 'FAQs',
    title: 'Features of AirClass',
    title1: 'Technical Question',
    q: 'Q',
    feature: [
        {
            question: 'What features are available?',
            answer: 'There are interactive courseware, collaborative blackboard, and rich forms of student-teacher interaction in the classroom.Online help is available at any time if you encounter problems. After the live class, you can also view the class replay and review the content of the class.',
        },
        {
            question: 'Do I need a microphone and webcam?',
            answer: 'Yes, you will need a microphone and a webcam so that you can communicate directly with the tutor.',
        },
        {
            question: 'How does the playback feature work?',
            answer: 'Once the lesson starts, the system will automatically record the sound and lesson content during the lesson, and you can view the playback on the client after the lesson is over. Don’t worry about your privacy, your video picture will not be visible.',
        },
        {
            question: 'How do I use the online help?',
            answer: 'If you encounter any problems during the lesson, you can Click on the ‘Online help’ button in the upper right corner of the classroom. After you describe your question, our technical support staff will establish a dialogue with you instantly to solve your problem.',
        }
    ],
    enterClassRoom: ` <p>Before using AirClass, please close Zoom, Google Meet and other meeting programs. Then perform device detection.</p>
    <p>The camera can only be seen when both parties enter the classroom.</p>
    <p>Please re-plug the external device and check if it is connected. Refresh the classroom afterwards.</p>
    <p>If you still can't see it during the class, please check if you are using the correct client.</p>`,
    technicalSupport: [
        {
            question: 'Installation of a new version fails',
            answer: 'Please uninstall the old version first'
        },
        {
            question: 'My screen is blank when logging into the AirClass client.',
            answer: 'Please try to restart the client and log in again.'
        },
        {
            question: ' I can\'t see the schedule in the client',
            answer: 'Recent courses will appear on the home page. Please go to the course calendar to view all scheduled classes.'
        },
        {
            question: 'Can’t see your video or hear the sound after entering the classroom.',
            answer: 'Before using AirClass, please close Zoom, Google Meet and other meeting programs. Then perform device detection.\nThe camera can only be seen when both parties enter the classroom.\n' +
                'Please re-plug the external device and check if it is connected. Refresh the classroom afterwards.\n' +
                'If you still can\'t see it during the class, please check if you are using the correct client.\n'
        },
    ]


}